"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DISCARD_REASON_LABELS = exports.DISCARD_REASONS = exports.DEFAULT_DAYS_RESOLVED_TO_CLOSED = exports.ARCHIVED_TICKET_STATES = exports.OPEN_TICKET_STATES = exports.TERMINAL_TICKET_STATES = exports.TICKET_STATE_LABELS = exports.TICKET_STATES = void 0;
exports.isTerminal = isTerminal;
/**
 * Stati del ticket (DEC-002). Le etichette sono quelle mostrate in console.
 */
exports.TICKET_STATES = ['nuovo', 'in_lavorazione', 'in_attesa_utente', 'risolto', 'chiuso', 'scartato'];
exports.TICKET_STATE_LABELS = {
    nuovo: 'Nuovo',
    in_lavorazione: 'In lavorazione',
    in_attesa_utente: "In attesa dell'utente",
    risolto: 'Risolto',
    chiuso: 'Chiuso',
    scartato: 'Scartato',
};
/** Stati terminali: nessuna transizione in uscita (DEC-002). */
exports.TERMINAL_TICKET_STATES = ['chiuso', 'scartato'];
/** Stati «aperti»: il lavoro da fare, cioè i soli ticket della coda (PRD-004 US-1, #123). */
exports.OPEN_TICKET_STATES = ['nuovo', 'in_lavorazione', 'in_attesa_utente'];
/**
 * Stati dell'archivio (#123, decisione del product owner del 16/10/2026): Risolto, Chiuso e Scartato.
 * Un Risolto resta riapribile (DEC-002 regola 5): la riapertura lo riporta in coda.
 */
exports.ARCHIVED_TICKET_STATES = ['risolto', 'chiuso', 'scartato'];
/** Giorni da Risolto a Chiuso automatico, default della regola di coda (DEC-002). */
exports.DEFAULT_DAYS_RESOLVED_TO_CLOSED = 14;
exports.DISCARD_REASONS = ['duplicato', 'spam', 'non_pertinente'];
exports.DISCARD_REASON_LABELS = {
    duplicato: 'Duplicato',
    spam: 'Spam',
    non_pertinente: 'Non pertinente',
};
function isTerminal(state) {
    return exports.TERMINAL_TICKET_STATES.includes(state);
}
//# sourceMappingURL=ticket-state.js.map